import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Edit Package", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_packages_edit_package_form = _resolveComponent("packages-edit-package-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_packages_edit_package_form, {
      package: _ctx.singlePackage,
      packageCode: _ctx.packageCode,
      onDeletePackage: _ctx.onDeletePackage
    }, null, 8, ["package", "packageCode", "onDeletePackage"])
  ]))
}